import { graphql } from "generated/gql";

export const getPublicOrgDocument = graphql(/* GraphQL */ `
  query GetPublicOrganisation($subdomain: String!) {
    publicOrganisation(subdomain: $subdomain) {
      name
      subdomain
      avatarUrl
    }
  }
`);
